<style lang="scss" src="./Loader.scss"></style>

<span class="loader">Loading...</span>